import {Component, input} from '@angular/core';

@Component({
  selector: 'elcia-label',
  imports: [],
  templateUrl: './label.html',
  styleUrl: './label.scss',
})
export class Label {
  label = input.required<string>();
}
